import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"down\"><title>down</title><path d=\"M14 4.688q0 .234-.156.438l-5.328 6.609q-.203.266-.531.266t-.531-.266L2.157 5.141q-.172-.219-.141-.5t.25-.453.5-.141.453.25l4.766 5.922 4.797-5.953q.172-.219.453-.25t.5.141q.266.203.266.531z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/down.svg
// module id = 159
// module chunks = 0